
export enum ReviewTypeEnum {
    REVIEW = 1,
    AD = 2,
    ALL= 3,
}
export interface IReviewData {
  _id: string;
  description: string;
  name: string;
  linkUrl: string;
  image: string;
  reviewType: ReviewTypeEnum;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface ReviewState {
  List: IReviewData[];
  form: IReviewData;
  loading: boolean;
  buttonLoading: boolean;
  search: string;
  pageNo: number;
  pageSize: number;
  totalRow: number;
  orderBy: string;
  orderDir: string;
  isFileUpload: boolean;
}

export type InitialState = ReviewState;
